module.exports = __webpack_public_path__ + "img/2-5.1d6fa397.svg";